import * as cx from 'classnames';
import {
    BAZAAR,
    BZ2_ADD_PRODUCT,
    BZ2_FAQ,
    BZ2_WISHLIST,
    FORUM,
    GROUP_LIST,
    HEADING_SELLERS,
    LOG_IN,
    MY_ENTRIES,
    MY_SHOPPING,
    PB_MENU_FIND_MOM,
    PB_MENU_MY_ACTIVITY,
    PHOTOBLOGS,
    REGISTER_HERE,
    SERVER_FULL_NAME,
    SERVER_SLOGAN,
} from 'mk/autogenerated/translations/SiteMenu.69569456b615123a89d0a88cca1db9a8'
import { WIKI_CATEGORIES } from 'mk/autogenerated/wikiCategories';
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import filesUrl from 'mk/common/filesUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import {
    about_help_url,
    bazaar_single_page_create_product_url,
    bazaar_single_page_my_bazaar_url,
    bazaar_single_page_product_grid_url,
    bazaar_single_page_seller_search_url,
    bazaar_single_page_shopping_url,
    bazaar_single_page_wishlist_url,
    group_list_url,
    login_url,
    photoblog_index_category_url,
    photoblog_index_url,
    signup_url,
    user_directory_url,
} from 'mk/urls/functions';
import { about_privacy_and_cookie_policy_pattern } from 'mk/urls/patterns';
import * as forumUrls from 'mk2/apps/forum/urls';
import * as homeUrls from 'mk2/apps/home/urls';
import { wikiCategoryUrl } from 'mk2/apps/wiki/utils';
import Header from 'mk2/components/Header';
import Img from 'mk2/components/Img';
import Interpolate from 'mk2/components/Interpolate';
import Link from 'mk2/components/Link';
import NotificationMenu from 'mk2/components/NotificationMenu';
import PrivacyReminder from 'mk2/components/PrivacyReminder';
import { pageHeaderFetchFlaggedCountsTrigger, pageHeaderLoad } from 'mk2/containers/PageHeader/PageHeader.action';
import { BrandDaysData, MenuItem } from 'mk2/containers/PageHeader/PageHeader.reducers';
import { privacyLeafletAcceptTrigger } from 'mk2/containers/PrivacyReminder/PrivacyReminder.actions';
import styles from 'mk2/containers/SiteMenu/SiteMenu.mscss';
import Loadable from 'mk2/helpers/Loadable';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { modrykonikLogoUrl, url } from 'mk2/helpers/urls';
import {
    AppState,
    getPageHeaderState,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestPrivacyLeaflet,
    getRequestUser,
} from 'mk2/reducers';
import { MenuSelection, UserEntity } from 'mk2/schemas';
import { subscribeJam } from 'mk2/services/jam';
import { parse, stringify } from 'query-string';
import * as React from 'react';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { Sticky } from 'react-sticky';
import { CSSTransition } from 'react-transition-group';

/* UserMenu is displayed on user interaction - so we can code split it safely */
const MobileMenu = Loadable({
    loader: () => import('mk2/components/MobileMenu' /* webpackChunkName: "components.MobileMenu" */),
    modules: ['mk2/components/MobileMenu'],
    webpack: () => [ require.resolveWeak('mk2/components/MobileMenu') ],
});

interface OwnState {
    mobileMenuOpened: boolean;
}

interface OwnProps {
    menuSelection?: MenuSelection;
    fluxibleCompatibility: boolean;
    currentUrl: string;  // nemozeme pouzit withRouter(), ten nefunguje v bazari
    showHeader: boolean;
    isHeaderSticky: boolean;
    dummySticky?: boolean;
    mobileShowLogo?: boolean;
    headerHasBackBtn?: boolean;
    headerTitle?: React.ReactNode;
    headerLeft?: React.ReactNode;
    headerRight?: React.ReactNode;
    headerTabs?: JSX.Element[];
}

interface StateProps {
    requestUser: UserEntity;
    requestUserPermissions: string[];
    isMobile: boolean;
    heartsCount: number;
    unreadMails: number;
    newBazaarEvents: number;
    newBazaarSell: number;
    allBazaarSell: number;
    wallStatusNews: number;
    wishlistUpdates: number;
    groupsCount: number;
    brandDays: BrandDaysData; // TODO Merge with CampaignEntity in forum/schemas
    feedMenu: MenuItem[];
    privacyLeaflet: boolean;
}

interface DispatchProps {
    onLoad(username: string);
    onFetchFlaggedCounts();
    onPrivacyLeafletAccept();
}

type Props = OwnProps & StateProps & DispatchProps;

class SiteMenu extends React.PureComponent<Props, OwnState> {

    private notificationMenu: NotificationMenu;

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileMenuOpened: false,
        };
    }

    public render() {
        const {
            isMobile, privacyLeaflet, currentUrl, showHeader, isHeaderSticky, dummySticky, headerTabs,
        } = this.props;

        const currentPath = currentUrl && currentUrl.indexOf('?') > 0 ? currentUrl.substr(0, currentUrl.indexOf('?')) : currentUrl;
        const ignorePrivacyReminder = ACTIVE_SERVER_ID === 207 && currentPath === about_privacy_and_cookie_policy_pattern;

        if (!isMobile) {
            return (
                <>
                    {this.renderToastr()}
                    <div className={styles.SiteMenu}>
                        {!ignorePrivacyReminder && this.renderPrivacy()}
                        {ACTIVE_SERVER_ID !== 207 && this.renderDesktopTabs()}
                    </div>
                </>
            );
        } else {
            return (
                <div className={styles.SiteMenu}>
                    <div className={(dummySticky) ? styles.SiteMenu__mobileDummyStickyContainer : null}>
                        <input className={styles.SiteMenu__mobileMenu__trigger} id="mobileMenuTrigger" checked={this.state.mobileMenuOpened} type="checkbox" onChange={this.onMobileMenuChange} />
                        <label htmlFor="mobileMenuTrigger" className={cx(styles.SiteMenu__mobileOverlay, this.state.mobileMenuOpened && styles['SiteMenu__mobileOverlay--visible'])} />

                        {showHeader && (
                            <div className={cx(styles.SiteMenu__header, dummySticky ? styles.SiteMenu__mobileDummySticky : null)}>
                                {isHeaderSticky ? (
                                    <Sticky
                                        // force re-render if privacy leaflet is closed, or tabs are shown/hidden
                                        key={`render-on-change-of-${privacyLeaflet}-${headerTabs ? headerTabs.length : 0}`}
                                    >
                                        {({ style }) => (
                                            // top: 0 je pridane, aby header nebol odskoceny, inak ak sa zmeni urlko
                                            // z predchadzajucej stranke moze ostat nastaveny zly top offset
                                            <div style={{...style, top: 0}}>
                                                {!ignorePrivacyReminder && this.renderPrivacy()}
                                                {this.renderMobileHeader()}
                                            </div>
                                        )}
                                    </Sticky>
                                ) : (
                                    <div>
                                        {!ignorePrivacyReminder && this.renderPrivacy()}
                                        {this.renderMobileHeader()}
                                    </div>
                                )}
                            </div>
                        )}

                        {this.renderMobileMenu()}
                    </div>
                </div>
            );
        }
    }

    public renderPrivacy() {
        const { privacyLeaflet, currentUrl, fluxibleCompatibility, onPrivacyLeafletAccept } = this.props;

        return (
            <PrivacyReminder
                fluxibleCompatibility={fluxibleCompatibility}
                currentUrl={currentUrl}
                showPrivacyReminder={!privacyLeaflet}
                onPrivacyLeafletAccept={onPrivacyLeafletAccept}
            />
        );
    }

    public renderToastr() {
        return (
            <ReduxToastr
                position="top-center"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
            />
        );
    }

    public renderDesktopTabs() {
        const {
            heartsCount, unreadMails, wishlistUpdates, newBazaarEvents, newBazaarSell, allBazaarSell, groupsCount,
            wallStatusNews, menuSelection, requestUser, brandDays, fluxibleCompatibility,
        } = this.props;

        let activeSection;
        let activeItem;
        if (menuSelection && menuSelection.activeSection) {
            activeSection = menuSelection.activeSection;
        }
        if (menuSelection && menuSelection.activeItem) {
            activeItem = menuSelection.activeItem;
        }

        return (
            <div className={(activeSection === 'bazaar' || activeSection === 'photoblog' || activeSection === 'home' || activeSection === 'wiki') ? styles.SiteMenu__submenuActive : null}>
                <div className={styles.SiteMenu__main}>
                    <div className={styles.SiteMenu__container}>
                        <div className={cx(styles.SiteMenu__logo, (activeSection === 'home' || activeSection === 'wiki') ? styles['SiteMenu__menu--active'] : null)}>
                            <a
                                className={styles.SiteMenu__logoA}
                                title={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN}
                                href={homeUrls.homepage}
                            >
                                <Img
                                    lazy={false}
                                    height={34}
                                    width={150}
                                    alt={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN}
                                    src={modrykonikLogoUrl()}
                                />
                            </a>
                            <div className={styles.SiteMenu__subMenu}>
                                <ul className={styles['SiteMenu__subMenu--container']}>
                                    {WIKI_CATEGORIES.map((wikiCategory, i) => (wikiCategory.id !== 11  // nezobrazuj 'Ine'
                                        ? <li key={i} className={cx(styles['SiteMenu__subMenu--item'], (activeItem === wikiCategory.slug) ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><CompatibleLink fluxibleCompatibility={fluxibleCompatibility} to={wikiCategoryUrl(wikiCategory)} className={cx(styles['SiteMenu__subMenu--link'], (i === 0) ? styles['SiteMenu__subMenu--linkFirst'] : null, 'topmenu-submenuLink')}>{wikiCategory.name}</CompatibleLink></li>
                                        : null
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <ul className={styles.SiteMenu__menu}>
                            <li className={cx(styles['SiteMenu__menu--item'], (activeSection === 'bazaar') ? styles['SiteMenu__menu--active'] : null)}>
                                <a className={styles['SiteMenu__menu--link']} href={bazaar_single_page_product_grid_url()}>{BAZAAR}{(newBazaarEvents + newBazaarSell > 0) ? (<span className={cx(styles.SiteMenu__notify, styles['SiteMenu__notify--bazaar'])}>{newBazaarEvents + newBazaarSell}</span>) : null}</a>
                                <div className={styles.SiteMenu__subMenu}>
                                    {(requestUser && isAuthenticated(requestUser)) ? (
                                        <ul className={styles['SiteMenu__subMenu--container']}>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], (activeSection === 'bazaar' && activeItem === 'bazaar') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], 'topmenu-submenuLink')} href={bazaar_single_page_my_bazaar_url(requestUser.username)}>{MY_ENTRIES}{(newBazaarSell > 0) ? (<span className={cx(styles.SiteMenu__notify, styles['SiteMenu__notify--bazaar'])}>{newBazaarSell}</span>) : (allBazaarSell > 0) ? (<i>{allBazaarSell}</i>) : null}</a></li>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], (activeSection === 'bazaar' && activeItem === 'wishlist') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], styles['SiteMenu__subMenu--linkFirst'], 'topmenu-submenuLink')} href={bazaar_single_page_wishlist_url(requestUser.username)}>{BZ2_WISHLIST}{(wishlistUpdates > 0) ? (<i>{wishlistUpdates}</i>) : null}</a></li>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], (activeSection === 'bazaar' && activeItem === 'shopping') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], 'topmenu-submenuLink')} href={bazaar_single_page_shopping_url(requestUser.username)}>{MY_SHOPPING}{(newBazaarEvents > 0) ? (<span className={cx(styles.SiteMenu__notify, styles['SiteMenu__notify--bazaar'])}>{newBazaarEvents}</span>) : null}</a></li>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], (activeSection === 'bazaar' && activeItem === 'heading-sellers') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], 'topmenu-submenuLink')} href={bazaar_single_page_seller_search_url()}>{HEADING_SELLERS}</a></li>
                                            <li className={cx(styles['SiteMenu__subMenu--item'])}><a className={cx(styles['SiteMenu__subMenu--link'], 'topmenu-submenuLink')} href={about_help_url() + '#cat-howto-market'}>{BZ2_FAQ}</a></li>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], styles['SiteMenu__subMenu--itemAddLink'], (activeSection === 'bazaar' && activeItem === 'add-item') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], styles['SiteMenu__subMenu--linkAddLink'], 'topmenu-submenuLink')} href={bazaar_single_page_create_product_url()}><span className={cx(styles['SiteMenu__subMenu--addLinkIcon'], 'fa', 'fa-plus-circle')}/>{BZ2_ADD_PRODUCT}</a></li>
                                        </ul>
                                    ) : (
                                        <ul className={styles['SiteMenu__subMenu--container']}>
                                            <li className={cx(styles['SiteMenu__subMenu--item'])}><a className={cx(styles['SiteMenu__subMenu--link'], 'topmenu-submenuLink')} href={about_help_url() + '#cat-howto-market'}>{BZ2_FAQ}</a></li>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], styles['SiteMenu__subMenu--itemAddLink'], (activeSection === 'bazaar' && activeItem === 'add-item') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], styles['SiteMenu__subMenu--linkAddLink'], 'topmenu-submenuLink')} href={bazaar_single_page_create_product_url()}><span className={cx(styles['SiteMenu__subMenu--addLinkIcon'], 'fa', 'fa-plus-circle')}/>{BZ2_ADD_PRODUCT}</a></li>
                                        </ul>
                                    )}
                                </div>
                            </li>
                            <li className={cx(styles['SiteMenu__menu--item'], (activeSection === 'forum') ? styles['SiteMenu__menu--active'] : null)}>
                                <CompatibleLink fluxibleCompatibility={fluxibleCompatibility} className={styles['SiteMenu__menu--link']} to={forumUrls.forum}>{FORUM}</CompatibleLink>
                            </li>
                            <li className={cx(styles['SiteMenu__menu--item'], (activeSection === 'photoblog') ? styles['SiteMenu__menu--active'] : null)}>
                                <a className={styles['SiteMenu__menu--link']} href={photoblog_index_url()}>{PHOTOBLOGS}</a>
                                <div className={styles.SiteMenu__subMenu}>
                                    {(requestUser && isAuthenticated(requestUser)) ? (
                                        <ul className={styles['SiteMenu__subMenu--container']}>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], (activeSection === 'photoblog' && activeItem === 'group-list') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], styles['SiteMenu__subMenu--linkFirst'], 'topmenu-submenuLink')} href={group_list_url()}>{GROUP_LIST} {(groupsCount > 0) ? (<i>{groupsCount}</i>) : null}</a></li>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], (activeSection === 'photoblog' && activeItem === 'my-activity') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], 'topmenu-submenuLink')} href={photoblog_index_category_url('my-activity')}>{PB_MENU_MY_ACTIVITY}</a></li>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], (activeSection === 'photoblog' && activeItem === 'user-directory') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], 'topmenu-submenuLink')} href={user_directory_url()}>{PB_MENU_FIND_MOM}</a></li>
                                        </ul>
                                    ) : (
                                        <ul className={styles['SiteMenu__subMenu--container']}>
                                            <li className={cx(styles['SiteMenu__subMenu--item'], (activeSection === 'photoblog' && activeItem === 'group-list') ? cx(styles['SiteMenu__subMenu--active'], 'topmenu-activeLink') : null)}><a className={cx(styles['SiteMenu__subMenu--link'], styles['SiteMenu__subMenu--linkFirst'], 'topmenu-submenuLink')} href={group_list_url()}>{GROUP_LIST} {(groupsCount > 0) ? (<i>{groupsCount}</i>) : null}</a></li>
                                        </ul>
                                    )}
                                </div>
                            </li>
                            {(brandDays.activeViralCampaign) ? (
                                <li className={styles['SiteMenu__menu--item']}>
                                    <a className={styles['SiteMenu__menu--link']} href={brandDays.activeViralCampaign.logoUrl} title={brandDays.activeViralCampaign.title}>{(brandDays.activeViralCampaign.logoPrefix) ? (brandDays.activeViralCampaign.logoPrefix) : null}<Img className={styles['SiteMenu__menu--brandLogo']} src={filesUrl + brandDays.activeViralCampaign.logoHomepageImg} width={brandDays.logoDesktopWidth} height={brandDays.logoDesktopHeight} alt={brandDays.activeViralCampaign.title} /></a>
                                </li>
                            ) : null}
                        </ul>
                        {(requestUser && isAuthenticated(requestUser)) ? (
                            <NotificationMenu
                                ref={(r) => this.notificationMenu = r}
                                heartsCount={heartsCount}
                                unreadMails={unreadMails}
                                wallStatusNews={wallStatusNews}
                                fluxibleCompatibility={fluxibleCompatibility}
                                requestUser={requestUser}
                                activeSection={activeSection}
                                activeItem={activeItem}
                                onItemClick={this.menuClose}
                                relocateWithNextParam={this.relocateWithNextParam}
                            />
                        ) : (
                            <div className={styles.SiteMenu__user}>
                                <a className={styles['SiteMenu__user--loginLink']} href={this.relocateWithNextParam(login_url())} rel="nofollow"><Interpolate i18nKey={LOG_IN} useDangerouslySetInnerHTML /></a>
                                <a className={cx(styles['SiteMenu__user--registerLink'], 'topmenu-registerLink')} href={this.relocateWithNextParam(signup_url({ mkutm_campaign: 'menu_registration', mkutm_source: 'modrykonik' }))} rel="nofollow">{REGISTER_HERE}</a>
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.SiteMenu__strap}>
                    <div className={styles.SiteMenu__container} />
                </div>
            </div>
        );
    }

    public renderMobileHeader() {
        const {
            unreadMails, newBazaarEvents, newBazaarSell, wallStatusNews, isMobile, mobileShowLogo,
            headerHasBackBtn, headerTitle, headerLeft, headerRight, headerTabs,
        } = this.props;

        return (
            <div className={styles.SiteMenu__header__content}>
                <Header
                    heading={headerTitle}
                    left={headerLeft}
                    right={headerRight}
                    isMobile={isMobile}
                    hasBackBtn={headerHasBackBtn}
                    notifications={unreadMails + newBazaarEvents + newBazaarSell + wallStatusNews}
                    showLogo={mobileShowLogo}
                />

                {headerTabs && headerTabs.length && (
                    <div className={styles.SiteMenu__header__tabs}>
                        {headerTabs.map((tab, index) => tab && (
                            <div key={index} className={styles.SiteMenu__header__tab}>{tab}</div>
                        ))}
                    </div>
                )}

                {this.renderToastr()}
            </div>
        );
    }

    public renderMobileMenu() {
        const {
            heartsCount, unreadMails, wishlistUpdates, newBazaarEvents, newBazaarSell, allBazaarSell, groupsCount,
            wallStatusNews, currentUrl, brandDays, feedMenu, fluxibleCompatibility, requestUser, menuSelection,
        } = this.props;

        let activeSection;
        let activeItem;
        if (menuSelection && menuSelection.activeSection) {
            activeSection = menuSelection.activeSection;
        }
        if (menuSelection && menuSelection.activeItem) {
            activeItem = menuSelection.activeItem;
        }

        return (
            <CSSTransition
                classNames={{
                    enter: styles['SiteMenu__mobileMenu--enter'],
                    enterActive: styles['SiteMenu__mobileMenu--enterActive'],
                    exit: styles['SiteMenu__mobileMenu--exit'],
                    exitActive: styles['SiteMenu__mobileMenu--exitActive'],
                }}
                in={this.state.mobileMenuOpened}
                mountOnEnter
                unmountOnExit
                timeout={300}
            >
                <div className={styles.SiteMenu__mobileMenu__content}>
                    <MobileMenu
                        requestUser={requestUser}
                        fluxibleCompatibility={fluxibleCompatibility}
                        activeSection={activeSection}
                        activeItem={activeItem}
                        currentUrl={currentUrl}
                        heartsCount={heartsCount}
                        unreadMails={unreadMails}
                        newBazaarEvents={newBazaarEvents}
                        newBazaarSell={newBazaarSell}
                        allBazaarSell={allBazaarSell}
                        wallStatusNews={wallStatusNews}
                        wishlistUpdates={wishlistUpdates}
                        groupsCount={groupsCount}
                        brandDays={brandDays}
                        feedMenu={feedMenu}
                        onItemClick={this.menuClose}
                        relocateWithNextParam={this.relocateWithNextParam}
                    />
                </div>
            </CSSTransition>
        );
    }

    public componentDidMount() {
        const {requestUser, requestUserPermissions, onFetchFlaggedCounts, isMobile} = this.props;

        // do not need to call onLoad(), initial data are passed from django via html
        // onLoad(requestUser.username);

        // fetch asynch count of flagged posts and groups
        const isAdmin = requestUserPermissions.indexOf('photoblog.can_remove_from_feed') >= 0;
        if (isMobile && isAdmin) {
            onFetchFlaggedCounts();
        }

        subscribeJam('userbar:' + requestUser.username);
    }

    private relocateWithNextParam = (thisHref) => {
        const { currentUrl } = this.props;

        if (!currentUrl) {
            return thisHref;
        }

        // remove ?qs from urls
        const currentPath = currentUrl.indexOf('?') > 0 ? currentUrl.substr(0, currentUrl.indexOf('?')) : currentUrl;
        const hrefPath = thisHref.indexOf('?') > 0 ? thisHref.substr(0, thisHref.indexOf('?')) : thisHref;

        if (currentPath === hrefPath) {
            return thisHref;
        } else {
            const hrefQS = thisHref.substring(hrefPath.length + 1);
            const qs = parse(hrefQS);
            qs.next = currentUrl;
            return `${hrefPath}?${stringify(qs)}`;
        }
    };

    private menuClose = () => {
        this.setState({
            mobileMenuOpened: false,
        });
        if (this.notificationMenu) {
            this.notificationMenu.close();
        }
    };

    private onMobileMenuChange = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            mobileMenuOpened: event.currentTarget.checked,
        });
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        requestUser: getRequestUser(state),
        requestUserPermissions: getRequestPermissions(state),
        isMobile: getRequestDeviceMobile(state),
        heartsCount: getPageHeaderState(state).userData.heartsCount,
        unreadMails: getPageHeaderState(state).userData.unreadMails,
        newBazaarEvents: getPageHeaderState(state).userData.newBazaarEvents,
        newBazaarSell: getPageHeaderState(state).userData.newBazaarSell,
        allBazaarSell: getPageHeaderState(state).userData.allBazaarSell,
        wallStatusNews: getPageHeaderState(state).userData.wallStatusNews,
        wishlistUpdates: getPageHeaderState(state).userData.wishlistUpdates,
        groupsCount: getPageHeaderState(state).userData.groupsCount,
        brandDays: getPageHeaderState(state).brandDays,
        feedMenu: getPageHeaderState(state).feedMenu,
        privacyLeaflet: getRequestPrivacyLeaflet(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onLoad: pageHeaderLoad,
    onFetchFlaggedCounts: pageHeaderFetchFlaggedCountsTrigger,
    onPrivacyLeafletAccept: privacyLeafletAcceptTrigger,
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteMenu);

interface CompatibleLinkOwnProps {
    fluxibleCompatibility: boolean;
    to: string;
    className?: string;
    rel?: string;
    onClick?();
}

export const CompatibleLink: React.StatelessComponent<CompatibleLinkOwnProps> = ({ to, onClick, className, fluxibleCompatibility, rel, children }) => {
    return fluxibleCompatibility ? (
        <a className={className} href={to} onClick={onClick} rel={rel}>{children}</a>
    ) : (
        <Link className={className} to={to} onClick={onClick} rel={rel}>{children}</Link>
    );
};
